import React, {useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import Image from 'react-bootstrap/Image';
import Scrollbars from 'react-custom-scrollbars';

export interface ImagePickerProps {
  images: string[];
  itemprop?: string;
  selectedVariantImage?:any;
  variantsImage:string[];
  fromWhere?:boolean;
  primaryImage:string;
  articleImage?:boolean;
}
const ImagePicker: React.FC<ImagePickerProps> = (props) => {
  const classes = useStyles();
  const [selectedImage, setSelectedImage] = useState(0);
  let arrayOfImage=[props.primaryImage];
  arrayOfImage.push(...props.variantsImage.filter((image)=>image!=null))
  arrayOfImage.push(...props.images.filter((image)=>image!=null))
  const node=document.getElementById("changeImageNotFromVariants");
  return (
    <div className={classes.pickerContainer}>
          <div
          className={classes.displayedImgBox}
          itemProp={props.itemprop}
          style={{
            backgroundImage: props.fromWhere ? `url(${props.variantsImage[props.selectedVariantImage]})` : `url(${arrayOfImage[selectedImage]})`,
          }}
          />
          {!props.articleImage ? (
          <Scrollbars
            style={{ width: '100%', height: 150 }}
            renderTrackVertical={() => <div />}
          >
              <div className={classes.imagePicker}>
              {arrayOfImage.map((image, index) => (
                <div
                  className={classes.choiceImgBox}
                  key={index}
                  onClick={()=>{setSelectedImage(index);node?.click();}}
                >
                  <Image className={classes.choiceImg} src={image} />
            </div>
            ))}
            </div>
            </Scrollbars>
            ):(null)}
    </div>
  );
};
const useStyles = createUseStyles({
  pickerContainer: {},
  displayedImgBox: {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    border: '1px solid #eeeeee',
    borderRadius: '15px',
    padding: '5px',
    minHeight: '390px',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
  },
  imagePicker: {
    display: 'flex',
    marginTop: '30px',
    cursor: 'pointer',
    overflowX: 'auto',
    width: '100%',
    '&::-webkit-scrollbar': {
      height:'0.6em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 10 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#778ca3',
      borderRadius: '20px',
      outline: '0px solid slategrey'
    }
  },
  choiceImgBox: {
    minWidth: '80px',
    margin: '5px',
    width: '80px',
    height: '80px',
    border: '1px solid #eeeeee',
    borderRadius: '10px',
    padding: '5px',
    cursor: 'pointer',
  },
  choiceImg: {
    objectFit: 'cover',
    width: '100%',
    height: '100%',
  },
});

export default ImagePicker;
